module.exports = new Promise((resolve, reject) => {
  const script = document.createElement("script");
  // Всегда используем nginx proxy путь (работает и на dev, и на production)
  script.src = `${window.location.protocol}//${window.location.host}/calculators/remoteEntry.js`;
  script.onload = () => {
    const module = {
      get: (request) => window.calculators.get(request),
      init: (arg) => {
        try {
          return window.calculators.init(arg);
        } catch (e) {
          console.log("Calculators remote has already been loaded");
        }
      },
    };
    resolve(module);
  };
  script.onerror = () => {
    reject(new Error('Calculators remote init error'));
  };
  document.head.appendChild(script);
});